import React, { useEffect, useState } from "react";
import { FlaskConical } from "lucide-react";
import { http } from "@/lib/api";

/** Global badge shown whenever the tenant runs on simulated agents. */
export default function SimulationBadge({ variant = "compact" }) {
    const [count, setCount] = useState(null);
    const [total, setTotal] = useState(null);

    useEffect(() => {
        let cancelled = false;
        const load = async () => {
            try {
                const { data } = await http.get("/dashboard/summary");
                if (!cancelled) {
                    setCount(data.agents_simulated ?? 0);
                    setTotal(data.agents_total ?? 0);
                }
            } catch {
                /* ignore */
            }
        };
        load();
        const iv = setInterval(load, 15000);
        return () => {
            cancelled = true;
            clearInterval(iv);
        };
    }, []);

    if (count === null || count === 0) return null;
    const allSimulated = total !== null && count === total;
    const label = allSimulated ? "Simulation mode" : `${count}/${total} simulated`;

    if (variant === "full") {
        return (
            <div
                className="flex items-center gap-2 rounded-sm border border-[hsl(var(--warning))] bg-[hsl(var(--warning))]/5 px-3 py-1.5"
                data-testid="simulation-badge"
            >
                <FlaskConical size={13} className="text-[hsl(var(--warning))]" />
                <span className="font-mono text-[10px] uppercase tracking-widest text-[hsl(var(--warning))]">
                    {label}
                </span>
                <span className="hidden text-[10px] text-muted-foreground sm:inline">
                    — data flows and metrics are synthetic.
                </span>
            </div>
        );
    }

    return (
        <span
            className="mb-pill border-[hsl(var(--warning))] text-[hsl(var(--warning))]"
            data-testid="simulation-badge"
            title="Simulated agents active — file payloads are synthetic; control-plane contract is identical to real agents."
        >
            <FlaskConical size={10} />
            {label}
        </span>
    );
}
